import { get } from 'lodash';

import type { Error } from '../types';

export const equalToField =
  (field: string, message?: Error['message']) =>
  (value: string, allValues: Record<string, string>) => ({
    valid: get(allValues, field) === value,
    message
  });
